<template>
  <div class="modal-add-item">
    <el-dialog
      class="dialog-form"
      append-to-body
      :visible.sync="visibleAddProduct"
      title="Thêm nhanh sản phẩm"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="productInfo"
        :model="productInfo"
        :rules="productInfoRules"
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Tên sản phẩm" prop="name">
              <el-input
                v-model="productInfo.name"
                placeholder="Nhập tên nhà cung cấp"
              />
            </el-form-item>
            <el-form-item label="Danh mục" prop="category">
              <el-select
                v-model="productInfo.category"
                @change="handleChangeCategory"
                placeholder="Lựa chọn nhà cung cấp"
                filterable
                class="width"
              >
                <el-option
                  v-for="(category, index) in categorys"
                  :key="index"
                  :label="category.label"
                  :value="category.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Mã SKU" prop="sku">
              <el-input
                v-model.trim="productInfo.sku"
                @input="(val) => (productInfo.sku = productInfo.sku.toUpperCase())"
                placeholder="Nhập SKU"
              />
            </el-form-item>
            <el-form-item label="Loại sản phẩm" prop="categoryId">
              <el-select
                v-model="productInfo.categoryId"
                :loading="loadingType"
                placeholder="Lựa chọn loại sản phẩm"
                filterable
                class="width"
              >
                <el-option
                  v-for="(type, index) in types"
                  :key="index"
                  :label="type.label"
                  :value="type.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="Đơn vị tính" prop="unit">
          <el-select
            v-model="productInfo.unit"
            placeholder="Lựa chọn đơn vị tính"
            filterable
            class="width"
          >
            <el-option
              v-for="(unit, index) in units"
              :key="index"
              :label="unit.label"
              :value="unit.label"
            />
          </el-select>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Giá nhập" prop="priceImport">
              <input
                type="text"
                class="form-control"
                v-model="productInfo.importPrice"
                placeholder="Giá nhập"
                @keydown="allowNumbersOnly"
                @input="
                  productInfo.importPrice = formatMoney(productInfo.importPrice)
                "
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Giá bán" prop="priceExport">
              <input
                type="text"
                class="form-control"
                v-model="productInfo.exportPrice"
                placeholder="Giá nhập"
                @keydown="allowNumbersOnly"
                @input="
                  productInfo.exportPrice = formatMoney(productInfo.exportPrice)
                "
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template slot="footer">
        <el-button type="text" @click="visibleAddProduct = false"
          >Thoát</el-button
        >
        <el-button
          type="primary"
          :loading="btnLoading"
          @click="btnConfirmAddProduct()"
          >Hoàn tất</el-button
        >
      </template>
    </el-dialog>
    <el-button :type="color" v-if="type === 'button'" @click="handleModal()">
      {{ text }}
    </el-button>
    <div v-else :class="'text-'+color" style="font-weight: bold; cursor: pointer;" @click="handleModal()">
      {{ text }}
    </div>
  </div>
</template>

<script>
import { validSKU } from '../../utils/validate';
import getListUnit from "@/mixins/items/getListUnit";
import getListCategory from "@/mixins/items/getListCategory";
import { CategoryService } from '../../services/nextshop/category.service'
import { ProductService } from "@/services/nextshop/product.service";
import { checkSKU } from '../../mixins/storage/checkSerial';
import { formatMoney } from '@/utils/mapping'
import handlerReqCreatItem from "@/mixins/orders/reqAddItem";
export default {
  props: {
    // text, button
    type: {
      type: String,
      default: "text",
    },
    text: {
      type: String,
      default: "",
    },
    // primary, success, warning, danger
    color: {
      type: String,
      default: "primary",
    },
  },
  mixins: [getListUnit, getListCategory, handlerReqCreatItem],
  data() {
    let validInputSKU = (rule, value, callback) => {
      if (value) {
        if (validSKU(value)) {
          return callback(new Error('SKU không được chứa kí tự đặc biệt'))
        }
        checkSKU(value).then(res => {
          if (res.success && res.data.length > 0) {
            return callback(new Error('SKU đã tồn tại trong hệ thống'))
          } else {
            callback()
          }
        })
      } else {
        callback()
      }
    }
    return {
      btnLoading: false,
      visibleAddProduct: false,
      loadingType: false,
      productInfo: {},
      productInfoRules: {
        name: [{ required: true, message: 'Không được để trống' }],
        category: [{ required: false, message: 'Không được để trống' }],
        categoryId: [{ required: false, message: 'Không được để trống' }],
        sku: [{ validator: validInputSKU, trigger: 'blur' }]
      },
      units: [],
      categorys: [],
      types: []
    }
  },
  methods: {
    formatMoney(val) {
      const result = formatMoney(val)
      return result
    },
    removeDot(val) {
      if (val) {
        return val.toString().split('.').join('')
      } else {
        return 0
      }
    },
    async handleModal() {
      this.visibleAddProduct = true
      const units = await this.getListUnit();
      this.units = units.map(unit => {
        return {
          value: unit.id,
          label: unit.unitName
        }
      })
      const categorys = await this.getListCategory();
      this.categorys = categorys.map(category => {
        return {
          value: category.id,
          label: category.name
        }
      })
    },
    handleChangeCategory() {
      const params = {
        queryString: { parentId: { eq: this.productInfo.category } },
        sort: "-id",
        lastItem: "",
        limit: 100,
      }
      this.loadingType = true
      CategoryService.getList(params).then(res => {
        this.loadingType = false
        if (res.success) {
          this.types = res.data.map(type => {
            return {
              value: type.id,
              label: type.name
            }
          })
        }
      })
    },
    btnConfirmAddProduct() {
      this.$refs.productInfo.validate(async (valid) => {
        if (valid) {
          const params = {
            name: this.productInfo.name.trim(),
            metaSearchable: {
              brand: "",
              madeBy: "",
              isSelling: true,
              category: this.productInfo.category,
            },
            priceItem: {
              exportPrice: parseInt(this.removeDot(this.productInfo.exportPrice)),
              importPrice: parseInt(this.removeDot(this.productInfo.importPrice)),
            },
            weightInGram: 0,
            upc: '',
            unit: {
              additionalUnits: [],
              name: this.productInfo.unit || 'Cái'
            },
            sku: this.productInfo.sku
          }
          this.btnLoading = true
          const req = this.handlerReqCreatItem(params, [])
          await ProductService.createItem(req).then(res => {
            if (res.success) {
              this.$message.success('Thêm sản phẩm thành công')
              this.visibleAddProduct = false
              this.$refs.productInfo.resetFields()
              this.$emit('response', res.data)
            } else {
              this.$emit('response', {})
            }
          })
        } else {
          console.log(valid);
        }
      })
    }
  }
};
</script>

<style></style>
